import { api } from '@api/api2';

const getData = () => api.v1('get', 'stories/bms/statuses');

export const apiRequests = { getData };
